// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.schedule-container {
  padding: 16px;
  max-width: 800px;
  margin: 0 auto;
}

.step-content {
  padding: 24px 0;
}
.step-content h3 {
  margin: 0 0 8px 0;
  color: #333;
  font-size: 1.2rem;
}
.step-content p {
  margin: 0 0 24px 0;
  color: #666;
}

.children-select {
  margin-bottom: 24px;
}
.children-select .full-width {
  width: 100%;
}

.selected-preview {
  background-color: #f5f5f5;
  padding: 16px;
  border-radius: 8px;
}
.selected-preview h4 {
  margin: 0 0 8px 0;
  color: #333;
}
.selected-preview p {
  margin: 0;
  color: #3880ff;
}

.locations-container {
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.locations-container .location-section h3 {
  margin-bottom: 16px;
}
.locations-container .location-section google-map {
  margin-bottom: 16px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.locations-container .location-section .full-width {
  width: 100%;
}

.schedule-fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 24px;
}

.recurring-section {
  margin: 24px 0;
}
.recurring-section .recurring-options {
  margin-top: 16px;
  padding: 16px;
  background-color: #f5f5f5;
  border-radius: 8px;
}
.recurring-section .recurring-options mat-form-field {
  width: 100%;
}
.recurring-section .recurring-options .days-select {
  margin: 16px 0;
}
.recurring-section .recurring-options .days-select mat-label {
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 8px;
  display: block;
}
.recurring-section .recurring-options .days-select mat-selection-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.recurring-section .recurring-options .days-select mat-selection-list mat-list-option {
  flex: 1;
  min-width: 100px;
  background-color: white;
  border-radius: 4px;
  margin: 0;
}
.recurring-section .recurring-options .date-range {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.full-width {
  width: 100%;
}

.step-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #eee;
}
.step-actions button {
  min-width: 120px;
}
.step-actions button mat-icon {
  margin-right: 8px;
}

@media (min-width: 768px) {
  .locations-container {
    flex-direction: row;
  }
  .locations-container .location-section {
    flex: 1;
  }
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/features/rides/schedule-ride/schedule-ride.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;AACF;AACE;EACE,iBAAA;EACA,WAAA;EACA,iBAAA;AACJ;AAEE;EACE,kBAAA;EACA,WAAA;AAAJ;;AAIA;EACE,mBAAA;AADF;AAGE;EACE,WAAA;AADJ;;AAKA;EACE,yBAAA;EACA,aAAA;EACA,kBAAA;AAFF;AAIE;EACE,iBAAA;EACA,WAAA;AAFJ;AAKE;EACE,SAAA;EACA,cAAA;AAHJ;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAJF;AAOI;EACE,mBAAA;AALN;AAQI;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;AANN;AASI;EACE,WAAA;AAPN;;AAYA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AATF;;AAYA;EACE,cAAA;AATF;AAWE;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AATJ;AAWI;EACE,WAAA;AATN;AAYI;EACE,cAAA;AAVN;AAYM;EACE,yBAAA;EACA,kBAAA;EACA,cAAA;AAVR;AAaM;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAXR;AAaQ;EACE,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;AAXV;AAgBI;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAdN;;AAmBA;EACE,WAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;AAhBF;AAkBE;EACE,gBAAA;AAhBJ;AAkBI;EACE,iBAAA;AAhBN;;AAqBA;EACE;IACE,mBAAA;EAlBF;EAoBE;IACE,OAAA;EAlBJ;AACF;AACA,wgJAAwgJ","sourcesContent":[".schedule-container {\n  padding: 16px;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.step-content {\n  padding: 24px 0;\n  \n  h3 {\n    margin: 0 0 8px 0;\n    color: #333;\n    font-size: 1.2rem;\n  }\n  \n  p {\n    margin: 0 0 24px 0;\n    color: #666;\n  }\n}\n\n.children-select {\n  margin-bottom: 24px;\n  \n  .full-width {\n    width: 100%;\n  }\n}\n\n.selected-preview {\n  background-color: #f5f5f5;\n  padding: 16px;\n  border-radius: 8px;\n  \n  h4 {\n    margin: 0 0 8px 0;\n    color: #333;\n  }\n  \n  p {\n    margin: 0;\n    color: #3880ff;\n  }\n}\n\n.locations-container {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  \n  .location-section {\n    h3 {\n      margin-bottom: 16px;\n    }\n    \n    google-map {\n      margin-bottom: 16px;\n      border-radius: 8px;\n      overflow: hidden;\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    }\n    \n    .full-width {\n      width: 100%;\n    }\n  }\n}\n\n.schedule-fields {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.recurring-section {\n  margin: 24px 0;\n  \n  .recurring-options {\n    margin-top: 16px;\n    padding: 16px;\n    background-color: #f5f5f5;\n    border-radius: 8px;\n    \n    mat-form-field {\n      width: 100%;\n    }\n    \n    .days-select {\n      margin: 16px 0;\n      \n      mat-label {\n        color: rgba(0, 0, 0, 0.6);\n        margin-bottom: 8px;\n        display: block;\n      }\n      \n      mat-selection-list {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 8px;\n        \n        mat-list-option {\n          flex: 1;\n          min-width: 100px;\n          background-color: white;\n          border-radius: 4px;\n          margin: 0;\n        }\n      }\n    }\n    \n    .date-range {\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      gap: 16px;\n    }\n  }\n}\n\n.full-width {\n  width: 100%;\n}\n\n.step-actions {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px solid #eee;\n  \n  button {\n    min-width: 120px;\n    \n    mat-icon {\n      margin-right: 8px;\n    }\n  }\n}\n\n@media (min-width: 768px) {\n  .locations-container {\n    flex-direction: row;\n    \n    .location-section {\n      flex: 1;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
